import * as React from 'react';
import {
	FormCheckConditional,
	ToggleSwitch,
	RadioGroup,
	Label,
	TextInput
} from '../../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onBlur: (value?: {}) => void;
	onChange: (value?: {}) => void;
}
const AviationQuestions: React.StatelessComponent<Props> = props => {
	const questionName = 'activities';
	const { onBlur, onChange } = props;
	return (
		<FormCheckConditional isOpen={props.questionnaire[questionName].aviation}>
			<RadioGroup
				title={props.questions.aviationLicense}
				name="aviationLicense"
				radioOptions={[
					{
						id: 'private',
						value: 'private',
						label: 'Private',
						checked: props.questionnaire[questionName].aviationLicense === 'private',
						onBlur: onBlur,
						onChange: onChange
					},
					{
						id: 'commercial',
						value: 'commercial',
						label: 'Commercial',
						checked: props.questionnaire[questionName].aviationLicense === 'commercial',
						onBlur: onBlur,
						onChange: onChange
					}
				]}
			/>
			<ToggleSwitch
				labelText={props.questions.aviationInstrumentRating}
				className="toggle-yes-no"
				name="aviationInstrumentRating"
				onChildren="Yes"
				offChildren="No"
				onBlur={onBlur}
				onChange={onChange}
				checked={props.questionnaire[questionName].aviationInstrumentRating}
			/>
			<div className="form-group">
				<Label>{props.questions.aviationHoursExperience}</Label>
				<TextInput
					name="aviationHoursExperience"
					className="form-group-number"
					pattern="[0-9]*"
					value={props.questionnaire[questionName].aviationHoursExperience}
					onBlur={onBlur}
					onChange={onChange}
				/>
			</div>
			<div className="form-group">
				<Label>{props.questions.aviationHoursAnnually}</Label>
				<TextInput
					name="aviationHoursAnnually"
					className="form-group-number"
					pattern="[0-9]*"
					value={props.questionnaire[questionName].aviationHoursAnnually}
					onBlur={onBlur}
					onChange={onChange}
				/>
			</div>
			<ToggleSwitch
				labelText={props.questions.aviationAccidents}
				className="toggle-yes-no mb-2"
				name="aviationAccidents"
				onChildren="Yes"
				offChildren="No"
				onBlur={onBlur}
				onChange={onChange}
				checked={props.questionnaire[questionName].aviationAccidents}
			/>
		</FormCheckConditional>
	);
};
export default AviationQuestions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/activitiesSubQuestions/AviationQuestions.tsx